export const CONCEPTOS = [
  {
    value: "cuota",
    label: "Cuota",
  },
  {
    value: "regulacion_cuota",
    label: "Regulación cuota",
  },
  {
    value: "gastos",
    label: "Gastos",
  },
  {
    value: "loteria",
    label: "Lotería",
  },
  {
    value: "rifa_presentacion",
    label: "Rifa presentación",
  },
  {
    value: "regalo_ffmm",
    label: "Regalo FFMM",
  },
  {
    value: "beneficio_loteria",
    label: "Beneficio de lotería",
  },
  {
    value: "regulacion_beneficios",
    label: "Regulación de beneficios",
  },
  {
    value: "loteria_centenario",
    label: "Lotería del centenario",
  },
  {
    value: "extra",
    label: "Extra",
  },
];

export const CONCEPTO_LABEL = Object.fromEntries(
  CONCEPTOS.map((concepto) => [concepto.value, concepto.label]),
);

export const TIPOS = CONCEPTOS.map((concepto) => concepto.value);
